export const InitPasswordVisibility = () => {
    const passwordToggleButtons = document.querySelectorAll('[data-toggle="password"]');

    if (passwordToggleButtons?.length > 0) {
        passwordToggleButtons.forEach(button => {
            const passwordMenu = document.getElementById(button.getAttribute('data-target'));
            if (passwordMenu) {
                button.addEventListener('click', () => {
                    const isPassword = passwordMenu.getAttribute('type') === 'password';
                    const icon = button.querySelector('.fa-solid');
                    const attribute = isPassword ? 'text' : 'password';
                    const addIconClass = isPassword ? 'fa-eye-slash' : 'fa-eye';
                    const removeIconClass = isPassword ? 'fa-eye' : 'fa-eye-slash';

                    passwordMenu.setAttribute('type', attribute);
                    if (icon) {
                        icon.classList.remove(removeIconClass);
                        icon.classList.add(addIconClass);
                        icon.classList.toggle('text-primary');
                    }
                    passwordMenu.focus();
                });
            }
        });
    }
};
